import { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  IconButton,
  Typography,
  Divider,
  Box,
  FormControl,
  Select,
  FormControlLabel,
  FormGroup,
  Switch,
  MenuItem,
  FormHelperText,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useDispatch, useSelector } from "react-redux";
import { getTenantAllUsersRequest } from "../../../../redux/clients/slice";
import Loading from "../../../../components/loading/loading";
import { qcAssignRequest } from "../../../../utils/APICalls";
import ErrorNotification from "../../../../components/error-notification/error-notification";
import { getOrderInspectionRequest } from "../../../../redux/orders/slice";

const styles = {
  icon: {
    position: "absolute",
    right: 12,
    top: 12,
    color: "rgba(0, 0, 0, 0.54)",
  },
  content: {
    mt: -2,
  },
  text: {
    color: "rgba(0, 0, 0, 0.87)",
  },
  save: {
    ml: 2,
    mr: 1,
  },
};

export default function AssignQCDialog({
  showDialog,
  closeDialog,
  orderNumber,
  orderId,
  orderIds,
  isSecondQC,
  onQCAssignSuccess,
}: any) {
  const dispatch = useDispatch();
  const [showLoading, setShowLoading] = useState(false);
  const [userId, setUserId] = useState("");
  const [secondQC, setSecondQC] = useState(false);
  const [submitCount, setSubmitCount] = useState(0);
  const [showErrorNotification, setShowErrorNotification] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const { loading, tenantAllUsers } = useSelector(
    (state: any) => state.clients
  );

  useEffect(() => {
    dispatch(getTenantAllUsersRequest());
    setSecondQC(isSecondQC ?? false);
  }, []); // eslint-disable-line

  const onSaveClick = () => {
    setSubmitCount((prev) => prev + 1);
    if (!userId) {
      return;
    }
    let payload: any = {};
    if (orderId) {
      payload = {
        orderIds: [orderId],
        qcUserId: userId,
        requireSecondQc: secondQC,
      };
    } else if (orderIds && orderIds.length > 0) {
      payload = {
        orderIds: orderIds,
        qcUserId: userId,
      };
    }
    assignQC(payload);
  };

  const assignQC = async (payload: any) => {
    setShowLoading(true);
    const response = await qcAssignRequest(payload);
    setShowLoading(false);
    if (response?.status === 200 || response?.status === 204) {
      if (orderId) {
        dispatch(getOrderInspectionRequest({ orderId }));
      }
      closeDialog();
      onQCAssignSuccess();
    } else if (response?.status === 400 || response?.status === 404) {
      setShowErrorNotification(true);
      setErrorMessage(response?.data?.detail);
    }
  };

  return (
    <Dialog
      open={showDialog}
      onClose={closeDialog}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      fullWidth
      maxWidth={"md"}
    >
      {orderId && (
        <DialogTitle id="alert-dialog-title" sx={{ fontWeight: "510" }}>
          QC Assign - Order #{orderNumber}
        </DialogTitle>
      )}

      {orderIds && orderIds.length === 1 && (
        <DialogTitle id="alert-dialog-title" sx={{ fontWeight: "510" }}>
          QC Assign for Order #{orderNumber}
        </DialogTitle>
      )}

      {orderIds && orderIds.length > 1 && (
        <DialogTitle id="alert-dialog-title" sx={{ fontWeight: "510" }}>
          Assign QC for Selected Orders
        </DialogTitle>
      )}

      <IconButton aria-label="close" onClick={closeDialog} sx={styles.icon}>
        <CloseIcon />
      </IconButton>
      <Divider />
      <DialogContent sx={styles.content}>
        <form>
          <Box className="user-name-layout">
            <Typography className="label-txt">Assigned Reviewer</Typography>
            <Box sx={{ width: "calc(100% - 180px)" }}>
              <FormControl
                sx={{ width: "100% !important" }}
                error={submitCount > 0 && !Boolean(userId)}
              >
                <Select
                  id="formTemplateId"
                  name="formTemplateId"
                  value={userId}
                  onChange={(e) => setUserId(e.target.value)}
                >
                  {tenantAllUsers?.map((user: any) => (
                    <MenuItem value={user.id}>{user.fullName}</MenuItem>
                  ))}
                </Select>
                {submitCount > 0 && !Boolean(userId) && (
                  <FormHelperText>This field is required.</FormHelperText>
                )}
              </FormControl>
            </Box>
          </Box>
          {orderId && (
            <>
              <Divider />
              <Box className="user-name-layout">
                <Typography className="label-txt">2nd QC Required?</Typography>
                <FormGroup>
                  <FormControlLabel
                    control={
                      <Switch
                        checked={secondQC}
                        onChange={(e) => setSecondQC(e.target.checked)}
                      />
                    }
                    label={secondQC ? "Yes" : "No"}
                  />
                </FormGroup>
              </Box>
            </>
          )}
        </form>
      </DialogContent>
      <Divider />
      <DialogActions>
        <Button onClick={closeDialog}>Cancel</Button>
        <Button
          sx={styles.save}
          variant="contained"
          autoFocus
          onClick={onSaveClick}
        >
          Save Changes
        </Button>
      </DialogActions>
      {showErrorNotification && (
        <ErrorNotification
          show={showErrorNotification}
          message={errorMessage}
          onClose={() => setShowErrorNotification(false)}
        />
      )}
      {(loading || showLoading) && <Loading />}
    </Dialog>
  );
}
